import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'

import { GetFormattedDate } from '../../../src/utils/helpers';
import { TimeZone } from './voy-tide-info-popup';
import '../../../assets/fonts/jsPDF/MaerskText';

export interface PdfExportParameters {
    chart: any, 
    portName: string, 
    fromDate: number, 
    toDate: number,
    tideData: number[][],
    timeZone: TimeZone
}

export class VoyTidePdfExport {
    public static Export(parms : PdfExportParameters) {
        const chartWidth = parms.chart.getWidth();
        const pixelRatio = 1050 / chartWidth;
        const chartHeightOnPrint = ( parms.chart.getHeight() * pixelRatio * 25.4 ) / 96;

        //@ts-ignore
        const doc = /** @type {jsPDF} */new jsPDF('landscape', 'mm', 'a4') ;
        const title = `TIDE - ${parms.portName}  ${GetFormattedDate(parms.fromDate)} - ${GetFormattedDate(parms.toDate)}  Time Zone: ${parms.timeZone.label}`;

        doc.setFont("MaerskText", "bold");
        doc.setFontSize(10);
        doc.text(`${title}`, 5, 10);
        doc.addImage(parms.chart.getDataURL({
            pixelRatio: pixelRatio,
            backgroundColor: '#fff'
        }), 'JPEG', 5, 15);
        
        const minMax = this._minMax(parms.tideData, parms.timeZone);

        autoTable(doc, {
            startY: 25 + chartHeightOnPrint + 5,
            theme: 'plain',
            columnStyles: {0: { fontStyle: 'bold', fontSize: 8, halign: 'center', cellWidth: 35 }, 1: { cellWidth: 20 , halign: 'center' },
                           2: { fontStyle: 'bold', fontSize: 8, halign: 'center', cellWidth: 35 }, 3: { cellWidth: 20 , halign: 'center' }},
            headStyles: { fontStyle: 'bold', fontSize: 8, halign: 'center' },
            rowPageBreak: 'auto',
            styles: {
                lineColor: [0, 0, 0],
                lineWidth: 0.1,
                cellPadding: {
                    top: 2,
                    right: 1,
                    left: 1,
                    bottom: 2
                },
                font: "MaerskText"
            },
            head: [ [{ content: 'Minima', colSpan: 2}, { content: 'Maxima', colSpan: 2}],
                     [{ content: 'Date', colSpan: 1}, { content: 'Height [m]', colSpan: 1}, { content: 'Date', colSpan: 1}, { content: 'Height [m]', colSpan: 1}]],
            body: [ ...minMax ]
        });
        
        doc.save(title+'.pdf');
    }

    private static _minMax(tideData: number[][], timeZone: TimeZone) {
        const minima: number[][] = [];
        const maxima: number[][] = [];

        let state = 0; // we have repeated heights in tide data, hence we need to prune it
        
        for (let i=1; i< tideData.length; i++) {
            if (tideData[i-1][1] < tideData[i][1]) {
                if (state === 1) {
                    minima.push(tideData[i]);
                }
                
                state = -1;
            }    

            if (tideData[i-1][1] > tideData[i][1]) {
                if (state === -1) {
                    maxima.push(tideData[i]);
                }
                state = 1;
            }    
        }

        //merge for table
        const printable : string[][] = [];
        for (let i=0; i< Math.max(maxima.length, minima.length); i++) {
            const minDate = minima[i] ? GetFormattedDate(minima[i][0] + timeZone.offset) : "";
            const maxDate = maxima[i] ? GetFormattedDate(maxima[i][0] + timeZone.offset) : "";
            const minHeight = minima[i] ? minima[i][1].toFixed(1) : "";
            const maxHeight = maxima[i] ? maxima[i][1].toFixed(1) : "";
            
            printable.push([minDate, minHeight, maxDate, maxHeight]);
        }

        return printable;
    }
}